<template>
	<div id="portfolio">
		<transition name="fade">
			<router-view/>
		</transition>
	</div>
</template>

<script>
	export default { name: "portfolio" }
</script>

<style lang="scss">
	@import "./styles/global.scss";
	/*
	.##.....##.##.....##.########.......##..######.
	.##.....##.##.....##.##.............##.##....##
	.##.....##.##.....##.##.............##.##......
	.##.....##.##.....##.######.........##..######.
	..##...##..##.....##.##.......##....##.......##
	...##.##...##.....##.##.......##....##.##....##
	....###.....#######..########..######...######.
	*/
	.fade-enter-active, .fade-leave-active {
		transition-property: opacity;
		transition-duration: .25s;
	}

	.fade-enter-active {
		transition-delay: .25s;
	}

	.fade-enter, .fade-leave-active {
		opacity: 0.0;
	}

	/*
	..######..##.....##....###....########..########.########.
	.##....##.##.....##...##.##...##.....##.##.......##.....##
	.##.......##.....##..##...##..##.....##.##.......##.....##
	..######..#########.##.....##.########..######...##.....##
	.......##.##.....##.#########.##...##...##.......##.....##
	.##....##.##.....##.##.....##.##....##..##.......##.....##
	..######..##.....##.##.....##.##.....##.########.########.
	*/
	body {
		background-color: $dark_contrast;
		margin: 0px;
		padding: 0px;
		color: $light_contrast;
	}

	#portfolio {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.no_text_select {
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none; /* Non-prefixed version, currently
													supported by Chrome and Opera */
	}
</style>



// WEBPACK FOOTER //
// src/app.vue